var popupStack = [];
jQuery(function ($) {

	///////////////////////
	///// progressbar /////
	///////////////////////////////////////////////////////////////////////////////////////////////
	setTimeout(function() {
		var progressEl = $(".inner-progress");
		var progress = progressEl.attr("data-progress") + "%";
		progressEl.css("width", progress);
	}, 1000);


	///////////////////////
	///// Mobile menu /////
	///////////////////////////////////////////////////////////////////////////////////////////////
	const leftSection = $(".left-section");
	const openMenu = $('.js-open-menu');
	const closeMenu = $('.js-close-menu');
	$(".floating-button").on('click', function (e) {
		e.preventDefault();

		leftSection.toggleClass("active");
		if(leftSection.hasClass('active')) {
			openMenu.attr('hidden', true);
			closeMenu.removeAttr('hidden');
		} else {
			closeMenu.attr('hidden', true);
			openMenu.removeAttr('hidden');
		}

	});


	/**
	 * breakpoints for responsivness
	 * @link https://github.com/jerrylow/breakpoints
	 */
	jQuery(window).breakpoints({
		breakpoints: [{
			"name": "sm",
			"width": 576
		}, {
			"name": "md",
			"width": 768
		}, {
			"name": "lg",
			"width": 992
		}, {
			"name": "xl",
			"width": 1200
		}]
	});

	/**
	 * detects external links and adds target="_blank"
	 */

	var host = window.location.host;

	jQuery('a').not('[href*="' + host + '"]').filter(function () {
		return this.hostname && this.hostname !== location.hostname;
	}).attr('target', '_blank').attr('rel', 'noopener');


	/**
	 * faq
	 */
	jQuery('.js-faq-question').on('click', function () {
		jQuery(this).siblings('.js-faq-answer').toggleClass('hidden');
		jQuery(this).find('.js-faq-icon').toggleClass('jam-plus');
	});



	////////////////////////
	///// popup /////
	///////////////////////////////////////////////////////////////////////////////////////////////
	$(document).on('click', '.js-popup-trigger', function(e) {
		var popup = $($(this).attr('href'));
		popup.addClass('active').removeAttr('hidden').focus();
		popupStack.push(popup);
	});


	$(".video-disabled").click(function (e) {
		e.preventDefault();
		$(".popup-background.video-alert-disabled").addClass("active");
	});

	$(".popup-close").click(function (e) {
		e.preventDefault();

		var target = jQuery(e.target);
		//if user clicks on chapter finished button, reload the page
		if (target.parent().parent().hasClass('chapter-alert-finished')) {
			window.location.reload();
		}

		if (!target.parent().parent().hasClass('training-alert-finished')) {
			$(".popup-background.summary").removeClass("active");
		}

		$(this).closest('.popup-background, .certificate-background').removeClass('active').attr('hidden', true);
		popupStack.pop();
		if(popupStack.length > 0) {
			popupStack[popupStack.length - 1].focus();
		}

	});

	$(".popup-close-reset").on('click', function (e) {
		$(".popup-background.reset").removeClass("active");
	});

	//close currently active dialog when user presses Escape key
	$(document).on('keyup', function(e) {
		if(e.key === 'Escape' && popupStack.length > 0) {
			popupStack[popupStack.length - 1].find('.popup-close, .video-close').trigger('click');
		}
	});



	/* Summary popup

	*/
	$(".popup-background.summary").find(".bg-blue").click(function (e) {
		$(".popup-background.summary").removeClass("active");
		$(".popup-background").removeClass("active");
		$(".video-background").removeClass("active");


	});



///// WORDS

	$(".questionsAndAnswers__title").click(function () {
		$(this).toggleClass('active');
		$(this).siblings(".questionsAndAnswers__content").slideToggle("fast");
	});


	//nav
	jQuery(function($) {
		var path = window.location.pathname; // because the 'href' property of the DOM element is the absolute path
		$('.nav a').each(function() {
			if ( this.pathname === path && this.href.indexOf('#') === -1) {
				$(this).find('li').addClass('active');
			}
		});
	});

	$(document).on('click', '.js-del-user-dg', function() {
		var $this = $(this);
		$('#dlt_person_name').text($this.data('name'));
		$($this.attr('href') + ' .js-del-user').data('userid', $this.data('userid'));
	});
	$(document).on('click', '.js-del-user', function() {
		jQuery.ajax({
			url: ajax.ajaxurl,
			data: {
				action: 'delete_user',
				userId: $(this).data('userid')
			},
			type: "POST",
			success: function(success) {
				if(success) {
					$('#confirm_delete_dg a.popup-close').trigger('click');
					//update users list after status change
					const status = $('#filter_training_status').val();
					filter_logic( status );
					getRegionNumbers( status );
				} else {
					$('#confirm_delete_dg .popup-bottom').html('<p class="text-paragraph font-light">Vi kunde tyvärr inte genomföra detta just nu, vänligen pröva igen senare.</p>');
				}
			}
		});
	});


	var loader = '<img class="loader" src="/wp-content/themes/patientnamnden/build/assets/images/loader.svg" />';
	//filter the table by training status
	$('#filter_training_status').on('change', function() {
		var option = this.value;
		filter_logic(option);
	});

	//filter users depending on what filter option is selected,
	function filter_logic(option) {
		if (option == "finished" || option == "ongoing" || option == "archived") {
			filter("filter", option)
		} else if(option == "alla"){
			filter("filter")
		}
	}

	//send data to backend to get filtered list.
	function filter(action, status){
		const data = {
			action:action,
			status: status
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			beforeSend: function() {
				$(".statistics").find("tbody").empty();
				$(".statistics").find("tbody").append(loader);
			},
			success: function(data) {
				$(".statistics").find("tbody").append(data);
				$('.loader').remove();
			}
		});
	}

	function getRegionNumbers(status){
		const data = {
			action:"get_region_numbers",
			status: status
		};

		jQuery.ajax({
			url: ajax.ajaxurl,
			data: data,
			type: "POST",
			beforeSend: function() {
				$("#filter_training_status").empty();
				$(".statistics").find("tbody").append(loader);
			},
			success: function(data) {
				$("#filter_training_status").append(data).val(status);
				$('.loader').remove();

			}
		});
	}


	/**
	 * cookie disclaimer
	 */
	jQuery(".js-cookie-disclaimer-accept").on("click", function (e) {
		e.preventDefault();
		jQuery(".js-cookie-disclaimer").removeClass("js-cookie-disclaimer-active");
		var valObj = {
			fullSite: true,
		}
		setCookie("CookieConsent", valObj, 10);
	});

	function setCookie(name, values, exdays, options = {}) {
		var d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		options = {
			path: "/",
			expires: d.toGMTString(),
			...options
		};

		let cookie = encodeURIComponent(name) + '=' + JSON.stringify(values)

		for (let optionKey in options) {
			cookie += "; " + optionKey;
			let optionValue = options[optionKey];
			if (optionValue !== true) {
				cookie += "=" + optionValue;
			}
		}

		document.cookie = cookie;
	}

	$('.js-logout').on('click', function(e) {
		e.preventDefault();
		logout(function(r) {
			window.location = '/';
		});
	});
});


function logout(fnCallback) {
	jQuery.ajax({
		url: ajax.ajaxurl,
		data: {
			'action': 'logout'
		},
		type: 'POST',
		success: fnCallback
	})
}




